var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dam-layout',{attrs:{"content-container":false}},[_c('create-assets',{attrs:{"collections":_vm.collections,"categories":_vm.categories}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }